// extracted by mini-css-extract-plugin
export default {"leftContent":"index_leftContent_minup","artical":"index_artical_Ij0Pq"};